export enum ApplicationFormVariant {
    DEFAULT,
    CREDIT
}
